import React, { useEffect } from 'react'
import reactDom from 'react-dom';
import { Row, Col, Modal, ModalBody, Button } from 'reactstrap';
import IconTrue from '../../assets/images/game/w2_soal/icon/TRUE.svg'
import IconFalse from '../../assets/images/game/w2_soal/icon/FALSE.svg'
import CloseModals from '../../assets/images/icons/close-modals.svg';

const CheckAnswer = ( props ) => {

    const handleModalClose = () => {
        props.setIsOpen(!props.isOpen)
    } 

    if (props.isOpen) {

        const AnswerHeader = () => {
            return (
                <>
                  <Row>
                      <Col className='text-center'>
                          <div>
                            {
                                props.Type === true 
                                ? <img src={IconTrue} alt="" /> 
                                : <img src={IconFalse} alt="" />
                            }
                          </div>
                          <div>
                              {
                                  props.Type === true 
                                  ? <p><b> Jawabanmu Benar </b></p> 
                                  : <p><b> Ups, Jawabanmu Kurang Tepat </b></p>
                              }
                          </div>
                          <div>
                              {
                                  props.Type === true 
                                  ? <p> Silahkan Melajutkan ke Soal Selanjutnya! </p>
                                  : <p> Silahkan baca pembenaran di bawah, kemudian <br /> baru melajutkan ke soal berikutnya. </p>
                              }
                          </div>
                      </Col>
                  </Row>
                </>
            )
        }

        return reactDom.createPortal(
            <>
                <Modal
                    size='lg'
                    isOpen={props.isOpen}
                    toggle={() => { props.setIsOpen(!props.isOpen); }}
                >
                    <ModalBody>
                        <Button onClick={handleModalClose} className="border-0 bg-transparent position-absolute close-modals-2" >
                            <img src={CloseModals} alt="close-modals" />
                        </Button>
                    </ModalBody>
                    <ModalBody className='px-lg-5 px-sm-1 modal-body-answer'>
                        <AnswerHeader />    
                        {props.children}
                        
                    </ModalBody>
                </Modal>
            </>,
            document.querySelector("#modal-root"),
            document.body.style.overflow = 'hidden'
        );
    } else {
        document.body.style.overflow = 'auto'
        return null 
    }

}

export default CheckAnswer;